import { useDispatch, useSelector } from "react-redux";
import { checkLicense, refreshLicense, resetRefreshLicense } from "./actions";
import { getLicense, getRefreshLicenseReqInfo } from "./selectors";

export function useAbout() {
	const dispatch = useDispatch();

	return {
		checkLicense: () => dispatch(checkLicense()),
		refreshLicense: () => dispatch(refreshLicense()),
		resetRefreshLicense: () => dispatch(resetRefreshLicense()),

		license: useSelector(getLicense),
		refreshLicenseReqInfo: useSelector(getRefreshLicenseReqInfo),
	};
}
